import { EntityType, SpreadsheetMapping, SpreadsheetMappingType } from 'api'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { SpreadsheetMappingHelper } from 'model'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { Field } from 'view/components/inputs'
import React from 'react'
import { createSortedSpreadsheetMappingIdsSelector } from 'selectors/spreadsheetMappingSelectors'

export interface SpreadsheetMappingSelectboxProps extends SelectboxProps<SpreadsheetMapping, string> {
  mappingType?: SpreadsheetMappingType
}

const mappingTypeSelector = (_: {}, props: SpreadsheetMappingSelectboxProps) => props.mappingType

const spreadsheetMappingMapStateToProps = createStructuredSelector({
  optionKeys: createSortedSpreadsheetMappingIdsSelector(mappingTypeSelector),
  getOption: createEntityGetterSelector(EntityType.SPREADSHEET_MAPPING)
})

export const SpreadsheetMappingSelectbox = connect(spreadsheetMappingMapStateToProps, null, null, { forwardRef: true })(
  Selectbox
) as React.ComponentType<Omit<SpreadsheetMappingSelectboxProps, 'optionKeys' | 'getOption'>>

SpreadsheetMappingSelectbox.defaultProps = {
  getOptionText: SpreadsheetMappingHelper.getName,
  canClear: false
}

export const SpreadsheetMappingSelectboxField = Field(SpreadsheetMappingSelectbox)
